
<div class="h-5 text-center">@if(spacingIdx()){ L{{spacingIdx()}} }</div>
<div class="bg-gray-600 h-1.5"></div>
<!-- Spacing elements -->


<div class="flex justify-center p-1 h-4 "
     [ngClass]="spacingValues().overflowSpace
         ? 'bg-[#CE936F]'
         : ( spacingValues().span <= maxSpan() ? 'bg-secondary-300': 'bg-secondary-500' ) ">
</div>

<input #spanInput class="h-4 flex text-s text-center w-[inherit] hover:font-semibold focus:outline-none"
       disabled
       type="number"
       [value]="spacingValues().span"
       [max]="maxSpan()"
       [min]="0">